<template>
    <div class="home">
        <div class="home-line">
            <div class="line-left">
                <!-- 今日出勤 -->
                <div class="attent-box">
                    <div class="first-head">
                        <p  class="qyjs">今日出勤</p>
                        <p class="color10" style="margin-left:30px">出勤人数<span class="color10">{{attend.allNowCount}}</span>人</p>
                        <p class="color10">出勤率 <span class="color10">{{attend.countRate}} %</span></p>
                    </div>
                    <el-popover
                        placement="right"
                        width="600"
                        popper-class="comhome-pop"
                        trigger="hover">
                        <el-table :data="gridData1" height="100%">
                            <el-table-column property="name" label="项目" width="300"></el-table-column>
                            <el-table-column property="zzry" label="在职"></el-table-column>
                            <el-table-column property="chuQin" label="出勤"></el-table-column>
                            <el-table-column property="chuQinRatio" label="出勤比率">
                                <template slot-scope="scope">
                                    <a>{{scope.row.chuQinRatio}}%</a>
                                </template>
                            </el-table-column>
                        </el-table>
                        <div class="first-body" slot="reference">
                            <div class="first-body-item">
                                <div class="num color8" style="margin: 10px 0">
                                    <p
                                        :class="{'number-item': !isNaN(item) }"
                                        v-for="(item,index) in numLen1"
                                        :key="index"
                                    >
                                        <span v-if="!isNaN(item)">
                                        <i ref="numberItem">0123456789</i>
                                        </span>
                                        <span v-else>{{item}}</span>
                                    </p>
                                </div>
                                <p class="name">管理人员</p>
                            </div>
                            <div class="first-body-item">
                                <div class="num color8" style="margin: 10px 0">
                                    <p
                                        :class="{'number-item': !isNaN(item) }"
                                        v-for="(item,index) in numLen2"
                                        :key="index"
                                    >
                                        <span v-if="!isNaN(item)">
                                        <i ref="numberItem1">0123456789</i>
                                        </span>
                                        <span v-else>{{item}}</span>
                                    </p>
                                </div>
                                <p class="name">建筑工人</p>
                            </div>
                            <div class="first-body-item">
                                <div class="num color8" style="margin: 10px 0">
                                    <p
                                        :class="{'number-item': !isNaN(item) }"
                                        v-for="(item,index) in numLen3"
                                        :key="index"
                                    >
                                        <span v-if="!isNaN(item)">
                                        <i ref="numberItem2">0123456789</i>
                                        </span>
                                        <span v-else>{{item}}</span>
                                    </p>
                                </div>
                                <p class="name">特种人员</p>
                            </div>
                        </div>
                    </el-popover>
                    
                </div>
                <!-- 人员动态 -->
                <div class="person-box">
                    <div class="first-head" style="z-index: 10;">
                        <p class="qyjs">人员动态</p>
                    </div>
                    <div class="first-body">
                        <div>
                            <p style="text-align:left;margin-left:14px;margin-top:20px;" class="color10">累计采集<span class="color10" style="color:#228FFE">{{syn.zs}}</span>人</p>
                            <p style="text-align:left;margin-left:14px;margin-top:4px;" class="color10">实名占比<span class="color10" style="color:#228FFE"> {{syn.smRate}}</span></p>
                        </div>
                        <div class="echart1">
                            <div id="myChart1" style="width:100%; height:100%"></div>
                        </div>
                        <div class="first-gress">
                            <el-popover
                                placement="right"
                                width="600"
                                popper-class="comhome-pop"
                                trigger="hover">
                                <el-table :data="gridData2" height="100%">
                                    <el-table-column property="projectName" label="项目" width="240"></el-table-column>
                                    <el-table-column property="cjrs" label="累计采集"></el-table-column>
                                    <el-table-column property="zzrs" label="已入职"></el-table-column>
                                    <el-table-column property="wrzrs" label="未分配"></el-table-column>
                                    <el-table-column property="lzrs" label="离职"></el-table-column>
                                </el-table>
                                <div class="first-gress-con" slot="reference">
                                    <p class="color10"><span>在职人数</span><span>{{syn.zz}}</span></p>
                                    <p class="color10"><span>离职人数</span><span>{{syn.lz}}</span></p>
                                    <p class="color10"><span>未分配人数</span><span>{{syn.wzz}}</span></p>
                                </div>
                            </el-popover>
                        </div>
                    </div>
                </div>
            </div>
            <!-- 跑马灯 -->
            <div class="line-center">
                <el-carousel id="banner" ref="change"  @change="videoChange" trigger="click" :interval="5000" :autoplay="false" arrow="never" height="100%">
                    <el-carousel-item v-for="(item,index) in bans" :key="index">
                      <div style="width:46vw;height:100%;position: relative;background: #ddd;color:#000;" :title="item.title">
                          <img v-if="item.photoUrl.split('.')[item.photoUrl.split('.').length-1]!='mp4'" :src="item.photoUrl" style="width:100%;height:100%;" />
                          <div v-if="item.photoUrl.split('.')[item.photoUrl.split('.').length-1]=='mp4'" class="videoCont">
                            <video :id="item.id" @playing="cleardate" @ended="handlePause" class="videoA" controls="controls" :src="item.photoUrl" style="width:100%;object-fit: fill;height:100%;" />
                            <i @click="turnOn(item)" :class="tiemDone==0?'el-icon-video-play':'el-icon-video-pause'"></i>
                          </div>
                      </div>
                    </el-carousel-item>
                </el-carousel>
            </div>
            <div class="line-right">
                <!-- 安全教育 -->
                
                <div class="attent-box">
                    <p class="qyjs" style="text-align:left;margin-top:5px">安全教育</p>
                    <el-popover
                        placement="right"
                        width="100%"
                        popper-class="comhome-pop"
                        trigger="hover">
                        <el-table :data="gridData4" height="100%">
                            <el-table-column property="projectName" label="项目" width="240"></el-table-column>
                            <el-table-column property="paperNum" label="考试人数"></el-table-column>
                            <el-table-column property="allNum" label="总人数"></el-table-column>
                        </el-table>
                        <div class="second-body" slot="reference" style="height:72%;">
                            <div class="hight-pie2" id="pie1"></div>
                            <div class="hight-pie2" id="pie2"></div>
                        </div>
                    </el-popover>
                    <!-- <div class="second-footer" style="height:20%;">
                        <p class="total-p">未考试人数<span class="color6"> {{edc.nopaper}} </span>人</p>
                        <p class="total-p">未教育人数<span class="color6"> {{edc.nopaper}} </span>人</p>
                    </div> -->
                    </div>
                <!-- 项目巡查 -->
                <div class="person-box">
                    <p class="qyjs" style="text-align:left;margin-top:5px">安环检查</p>
                    <div class="second-body ">
                        <div class="table-head color1">
                            <p>项目</p>
                            <p>检查人</p>
                            <p>检查事项</p>
                            <p>检查时间</p>
                        </div>
                        <div class="table-head-list">
                            <ul :class="{anim:animate==true}">
                                <li class="table-li" v-for="item in postList" :key="item.id" style="height:4vh;">
                                    <p style="width:25%;">
                                        <span class="nowrapA" style="display: inline-block;width: 100%;" :title="item.projectName">{{item.projectName}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA">{{item.reportName}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA" style="display: inline-block;width: 100%;" :title="item.description">{{item.description}}</span>
                                    </p>
                                    <p style="width:25%;">
                                        <span class="nowrapA">{{item.reportDate}}</span>
                                    </p>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="home-line home-line1">
            <div class="line-left1">
                <el-popover
                    placement="right"
                    width="width: 25.6vw;"
                    popper-class="comhome-pop"
                    trigger="hover">
                    <el-table :data="gridData3" height="100%">
                        <el-table-column property="projectName" label="项目" width="300"></el-table-column>
                        <el-table-column property="progress" label="合同工期"></el-table-column>
                        <el-table-column property="bilv" label="进度产值"></el-table-column>
                    </el-table>
                    <div style="width:25.6vw;height: 100%;position: relative;border: 1px solid #ddd;border-radius: 0.3vh;" slot="reference">
                        <p class="qyjs" style="margin-top:5px;text-align:left;margin-bottom:30px;">项目统计</p>
                        <div class="second-body" style="height:80%;">
                            <div class="hight-pie2" id="pie3" style="height:100%;position: relative;padding-right:1vw;">
                                <!-- <el-progress type="circle" :percentage="proNum.typeLv"></el-progress> -->
                            </div>
                            <div class="hight-pie2" id="pie4" style="height:100%;position: relative;padding-left:1vw;">
                                <!-- <el-progress type="circle" :percentage="proNum.zLv" color="#E6A23C"></el-progress> -->
                            </div>
                        </div>
                        <div class="second-footer" style="height:15%;">
                            <!-- <div class="hight-pie2" style="height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;padding-left: 1vh;">
                                <p style="margin-right:1vh;height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#5B7EFF;margin-right:0.5vh;"></span>在建项目：{{parseInt(proNum.zbzj)+parseInt(proNum.fbzj)}}</p>
                                <p style="padding-left:0.5vh;height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#2E55E6;margin-right:0.5vh;"></span>竣工项目：{{parseInt(proNum.zbjg)+parseInt(proNum.fbjg)}}</p>
                                <p style="height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#1131AB;margin-right:0.5vh;"></span>停工项目：{{parseInt(proNum.zbtg)+parseInt(proNum.fbtg)}}</p>
                            </div>
                            <div class="hight-pie2" style="height:100%;position: relative;display:flex;flex-wrap:wrap;align-content: center;padding-left: 1vh;">
                                <p style="margin-right:1vh;height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#A8E2FF;margin-right:0.5vh;"></span>在建项目：{{proNum.jszj}}</p>
                                <p style="padding-left:0.5vh;height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#55BDF0;margin-right:0.5vh;"></span>竣工项目：{{proNum.jsjg}}</p>
                                <p style="height: 3vh;font-size: 0.6vw;"><span style="display: inline-block;width:1vh;height:1vh;border-radius: 50%;background:#1492D0;margin-right:0.5vh;"></span>停工项目：{{proNum.jstg}}</p>
                            </div> -->
                        </div>
                    </div>
                </el-popover>
            </div>
            <div class="line-center1">
                <div class="deme-box">
                    <div class="demo-head">
                        <p class="qyjs">企业介绍</p>
                        <!-- <p style="color:#409EFF;cursor: pointer;" @click="toProject">更多</p> -->
                    </div>
                    <div class="demo-body" style="overflow: hidden;">
                        <div class="box-cont" style="width:100%;height:100%;position: relative;" >
                            <div v-html="html"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="line1-right" style="height:100%;display:block;background-color: rgba(0,0,0,0);">
                <div class="pub-box" style="height:46%;background-color:#fff;margin-bottom: 5.3%;padding-left: 2vh;">
                    <div class="demo-head">
                        <p class="qyjA">企业精神</p>
                        <p style="color:#409EFF;cursor: pointer;font-size:14px;margin-right:20px" @click="toNotice">更多</p>
                    </div>
                    <div class="demo-body" style="overflow: auto;">
                        <ul class="demo-ul" :class="{anim2:animate2==true}">
                            <li class="table-li" v-for="(item,index) in noticeList" :key="index" style="height:4vh;align-content: center;align-items: center;">
                                <i class="el-icon-caret-right" style="color:#2061BE;font-size:12px"></i>
                                <p class="name" @click="toInfo(item,1)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.title">{{item.title}}</span></p>
                                <p class="dec" @click="toInfo(item,1)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.content">{{item.content}}</span></p>
                                <p class="time" style="font-size:12px">{{item.time}}</p>
                            </li>
                        </ul>
                        <!-- <div class="note-box">
                            <p class="name nowrap">{{notice.title}}</p>
                            <div class="con">{{notice.content}}</div>
                            <p class="foot">{{notice.time}}</p>
                        </div> -->
                    </div>
                     
                </div>
                <div class="pub-box" style="height:46%; background-color:#fff;padding-left: 2vh;">
                    <div class="demo-head">
                        <p class="qyjA">企业文化</p>
                        <p style="color:#409EFF;cursor: pointer;font-size:14px;margin-right:20px" @click="toLaws">更多</p>
                    </div>
                    <div class="demo-body" style="overflow: auto;">
                        <ul class="demo-ul" :class="{anim3:animate3==true}">
                            <li class="table-li" v-for="item in lawsList" :key="item.id" style="height:4vh;align-content: center;align-items: center;">
                                <i class="el-icon-caret-right" style="color:#2061BE;font-size:12px"></i>
                                <p class="name" @click="toInfo(item,2)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.title">{{item.title}}</span></p>
                                <p class="dec" @click="toInfo(item,2)"><span style="width:100%;display:inline-block;text-align: left;font-size:12px" class="nowrap" :title="item.content">{{item.content}}</span></p>
                                <p class="time" style="font-size:12px">{{item.time}}</p>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import HighCharts from 'highcharts'
import myHttp from '../../untils/port'
import util from '../../untils/util'
import base from '../../untils/base'
export default {
    data(){
        return {
            groupId:'',
            groupType:'',
            attend:{  //今日出勤
                manageCount:0, //管理人员数量
                workersCount:0, //工人人员数量
                specialCount:0, //特殊人员数量
                allNowCount:0,  //今日出勤的总人数
                countRate:0, //在班组的所有人员
            },
            numLen1:['9'],//今日出勤 - 管理人员长度
            numLen2:['0'],//今日出勤 - 建筑人员长度
            numLen3:['0'],//今日出勤 - 特种人员长度
            syn:{
                zz:0,   //在职
                wzz:0,  //未在职
                lz:0,  //离职
                sm:0,   //采集人数
                zs:0,   //总人数
                smRate:0,//实名率
                zzLv:'0%',  //在职比例
                wzzLv:'0%', //未在职比例
                lzLv:'0%', //未实名比例
            },
            postList:[  //项目巡查
                // {id:'1',name:'****项目',label:'*****事项',csSum:'达标'}
            ],
            edc:{ //安全教育
                allNum:0,
                paperNum:0,
                nopaper:0,
            },
            noticeList:[],
            lawsList:[],
            // notice:{
            //     id:'',
            //     title:'',
            //     time:''
            // },
            proNum:{
                all: 0,
                fb: 0,
                jg: 0,
                zcb: 0,
                zj: 0,
                typeLv:0,
                zLv:0,
            },
            bans:[
                // {id:1,url:require('../../assets/image/ban1.png')}
            ],
            proImg:[],

            animate:false, //滚动
            timer1:undefined,//定时器1
            animate2:false, //滚动2
            timer2:undefined,//定时器2
            animate3:false, //滚动3
            timer3:undefined,//定时器3
            animate4:false,
            timer4:undefined,

            mouseFlag : true,
            gridData1:[],
            gridData2:[],
            gridData3:[],
            gridData4:[],
            tiem:null,
            tiemDone:0,
            stop:true,
            html:''
        }
    },
    watch: {
        '$store.state.groupId': function(val, old) {
            if(!val||val==''){
                return;
            }
            this.groupId = util.session.get('groupId')
            //获取出勤
            this.getAttend()
            this.getCai()
            this.edcData()
            this.getProNum()
            this.getProjectList()
            this.getNotice()
            this.getBanner()
            this.getQs()
            //获取今日出勤列表
            if(this.groupId && ''!=this.groupId){
                this.getProWorker()
                this.getProPerson()
                this.getProTotal()
            }
        }
    },
    beforeDestroy(){
        clearInterval(this.tiem)
    },
    mounted(){
        this.groupId = util.session.get('groupId')
        this.proNum.typeLv = 0
        this.proNum.zLv = 0
        if(this.timer1){
            window.clearInterval(this.timer1)
        }
        if(this.timer2){
            window.clearInterval(this.timer2)
        }
        if(this.timer3){
            window.clearInterval(this.timer3)
        }
        if(this.timer4){
            window.clearInterval(this.timer4)
        }
        //获取今日出勤列表
        if(this.groupId && ''!=this.groupId){
            //获取出勤
            this.getAttend()
            this.getCai()
            this.edcData()
            this.getProNum()
            this.getProjectList()
            this.getNotice()
            this.getBanner()
            this.getQs()
            //获取弹出框数据
            this.getProWorker()
            this.getProPerson()
            this.getProTotal()
        }
        // this.$refs.movie.addEventListener("play",this.handlePlay)
        this.tiem = setTimeout(() => {
            this.$refs.change.next()
            document.querySelector('.videoA').controls=false
        }, 4000);
        // 鼠标移入轮播停止
        document.querySelector('#banner').onmouseover=()=>{
            document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                item.style.display='block'
            })
            this.stop = false
            console.log(this.tiem,'停止')
            if(this.tiem!=null){
                clearInterval(this.tiem)
                if(this.tiemDone==1){
                    document.querySelectorAll('.videoA').forEach(item=>{
                        item.controls=true
                    })
                }else{
                    document.querySelectorAll('.videoA').forEach(item=>{
                        item.controls=false
                    })
                }
            }
        }
        document.querySelector('#banner').onmouseout=()=>{
            this.stop = true
            document.querySelector('.videoA').controls=false
            if(this.tiemDone==1){
                document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                    console.log(item)
                item.style.display='none'
            })
            }else{
                this.tiem = setTimeout(() => {
            this.$refs.change.next()
            console.log('开始')
            
        }, 4000);
            }
        }
        this.getInfoByIdNew()
    },
    methods:{
        getInfoByIdNew(){
        myHttp.getInfoByIdNew({
          id:util.session.get('groupId'),
        }).then(res=>{
          console.log(res)
          if(res.data.code==200){
            this.html= res.data.data.enterprise.entDesc
          }
          
        })
      },
        turnOn(item){
            if(this.tiemDone!=1){
                this.tiemDone=1
                document.getElementById(item.id).play()
            }else{
                this.tiemDone=0
                document.getElementById(item.id).pause()
            }
        },
        handlePause(){
            document.querySelectorAll('.el-icon-video-pause').forEach((item,index)=>{
                item.style.display='block'
            })
            document.querySelectorAll('.videoA').forEach(item=>{
                item.controls=false
                this.tiemDone=0
                
            })
            this.tiem = setTimeout(() => {
            this.$refs.change.next()
        }, 4000);
        },
        cleardate(){
            clearInterval(this.tiem)
        },
        videoChange(){
             document.querySelectorAll('.videoA').forEach(item=>{
                item.controls=false
            })
            document.querySelectorAll('.videoA').forEach(item=>{
                item.pause()
                this.tiemDone=0
            })
           if(this.stop){
             console.log('shipinbofangla')
            clearInterval(this.tiem)
            this.tiem = setInterval(() => {
            this.$refs.change.next()
        }, 4000);
            // console.log(document.querySelectorAll('.videoA'))
            // document.getElementsByClassName('.movie').pause()
           }
        },
        //获取banner图
        getBanner(){
            var that = this
            myHttp.getBannerEnt({
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    for(var i=0;i<list.length;i++){
                        list[i].photoUrl = list[i].photoUrl && list[i].photoUrl!=''?base.httpCtx+list[i].photoUrl:''
                    }
                    if(list.length==0){
                        list.push( {id:1,photoUrl:require('../../assets/image/ban1.png'),title:''})
                    }
                    that.bans = list
                    console.log(that.bans)
                }else{
                    that.bans = [{id:1,photoUrl:require('../../assets/image/ban1.png'),title:''}]
                }
            })
        },
        //获取出勤
        getAttend(){
            var that = this
            myHttp.getDayAttendEnt({
                groupId:this.groupId,
                joinType:this.groupType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data || {}
                    console.log(data);
                    data.countRate = data.allTeamsCount && data.allTeamsCount!='0'?(parseInt(data.allNowCount)/parseInt(data.allTeamsCount)*100).toFixed(1):0
                    that.attend = data
                    that.refreshAttendData(data.manageCount,that.$refs.numberItem,1)
                    that.refreshAttendData(data.workersCount,that.$refs.numberItem1,2)
                    that.refreshAttendData(data.specialCount,that.$refs.numberItem2,3)
                }
            })
        },
        //获取采集人员
        getCai(){
            var that = this
            myHttp.entPersonDynamic({
                groupId:this.groupId,
                joinType:this.groupType
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var data = resp.data.data || {}
                    data.smRate = data.zs && data.zs!='0'?(parseInt(data.sm)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                    data.zzLv = data.zs && data.zs!='0'?(parseInt(data.zz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                    data.wzzLv = data.zs && data.zs!='0'?(parseInt(data.wzz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                    data.lzLv = data.zs && data.zs!='0'?(parseInt(data.lz)/parseInt(data.zs)*100).toFixed(1)+'%':'0%'
                    that.syn = data
                }
                that.setChart1()
            })
        },
        //获取教育
        edcData(){
            var that = this
            myHttp.entSafetyEducation({
                groupId:this.groupId,
                joinType:this.groupType
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data
                    data.nopaper = parseInt(data.allNum) - parseInt(data.paperNum)
                    that.edc = data
                    that.gridData4 = resp.data.data.entity||[]
                }
                that.setChart2()
                that.setChart21()
            })
        },
        //获取项目统计
        getProNum(){
            var that = this
            myHttp.getProSumEnt({
                groupId:this.groupId
            }).then(function(resp){
                // console.log(resp)
                if(resp.data.code=='200'){
                    var data = resp.data.data||{}
                    // data.typeLv = data.all==0?0:(parseInt(data.zcb)/parseInt(data.all)*100).toFixed(1)
                    // data.zLv = data.all==0?0:(parseInt(data.zj)/parseInt(data.all)*100).toFixed(1)
                    that.proNum = data
                    // that.proNum.typeLv = parseFloat(data.typeLv)
                    // that.proNum.zLv = parseFloat(data.zLv)
                }
                that.setChart4() //总包项目
                that.setChart5() //分包项目
            })
        },
        //获取项目列表
        getProjectList(){
            var that = this
            myHttp.getProjectPageListByEntIdAndJoinType({
                pageNum:1,
                pageSize:1000,
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list||[]
                    var result = []
                    for(var i=0;i<list.length;i++){
                        var imgs = list[i].photoPath && list[i].photoPath!=''? list[i].photoPath.split(','):[]
                        var img = []
                        for(var j=0;j<imgs.length;j++){
                            if(imgs[j]&&imgs[j]!=''){
                                img.push(base.httpCtx+imgs[j])
                            }
                        }
                        if(img.length>0){
                            var obj = {
                                id:list[i].id,
                                name:list[i].name,
                                url:img
                            }
                            result.push(obj)
                        }
                    }
                    that.proImg = result
                    // that.timer4 = setInterval(that.scroll4,2500)
                }
            })
        },

        //获取公告
        getNotice(){
            var that = this
            myHttp.getNoticeAndLawsList({
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list1 = resp.data.data.notices||[] //公告
                    var list2 = resp.data.data.laws||[] //法律
                    for(var i=0;i<list1.length;i++){
                        list1[i].time = list1[i].createDate.split(' ')[0]
                    }
                    for(var j=0;j<list2.length;j++){
                        list2[j].time = list2[j].createDate.split(' ')[0]
                    }
                    // if(obj){
                    //     obj.time = obj.createDate.split(' ')[0]
                    //     // that.notice = obj
                    // }
                    that.lawsList = list2
                    that.noticeList = list1
                    // that.noticeList.push(obj)
                    that.timer2 = setInterval(that.scroll2,2200) // 合同滚动
                    that.timer3 = setInterval(that.scroll3,1800) // 合同滚动
                }
            })
        },
        //获取项目巡查
        getQs(){
            var that = this
            myHttp.getQsListByEntIdAndJoinType({
                entId:this.groupId,
                type:'2',
                // startTime:util.myTime.getCurMonth()+'-01',
                // endTime:util.myTime.getCurMonth()+'-'+util.myTime.getMonthDay(),
                flag:'5',
                joinType:'',
                pageNum:'1',
                pageSize:'10',
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.qsList.list||[]
                    for(var i=0;i<list.length;i++){
                        list[i].reportDate = list[i].reportDate?list[i].reportDate.split(' ')[0]:''
                    }
                    that.postList = list
                    that.timer1 = setInterval(that.scroll1,2000) // 合同滚动
                }
            })
        },
        //人员动态环形图
        setChart1(){
            var data = {
                zz:this.syn.zz||0,
                wzz:this.syn.wzz||0,
                lz:this.syn.lz||0,
                zs:this.syn.zs||0
            }
            data.zz = data.zz==0?0.001:data.zz
            data.wzz = data.wzz==0?0.001:data.wzz
            data.wsm = data.wsm==0?0.001:data.wsm
            var chart = HighCharts.chart('myChart1', {
                subtitle:{
                    floating:true,
                    verticalAlign:'middle',
                    text:data.zs+'人',
                    style: {
                        fontSize: 10,
                        color: '#7058F8',
                    },
                    y:30,
                },
                title: {
                    // floating:true,
                    text: '人员动态',
                    verticalAlign:'middle',
                    style: {
                        fontSize:'10px'
                    },
                    y:10
                },
                tooltip: {
                    pointFormat: '<b>{point.y:.0f}</b>',
                    headerFormat:'<span style="font-size: 16px">{series.name}</span><br/><span style="font-size: 16px">{point.key}</span>：'
                },
                colors:['#228FFE','#F7B61C', '#F45E23'],
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            // formatter:function(){
                                
                            //     return this.y==0.001?'0%':this.percentage+' %'
                            // },
                            format: ' ',
                            style:{
                                fontSize:'10px'
                            },
                        },
                        point: {
                            events: {}
                        },
                    }
                },
                series: [{
                    type: 'pie',
                    innerSize: '70%',
                    name: '采集人数',
                    dataLabels:{
                        formatter: function () {
                            return this.point.name;
                        },
                        color: '#ffffff',
                        distance: -10,

                    },
                    data: [
                        ['在职', data.zz],
                        ['离职',data.lz],
                        ['未分配', data.wzz]
                    ]
                }]
            });
        },

        //入职考试和教育环形图
        setChart2(){
            var data = {
                paperNum:this.edc.paperNum||0,
                nopaper:this.edc.nopaper||0,
            }
            data.paperNum = data.paperNum==0?0.001:data.paperNum
            data.nopaper = data.wzz==0?0.001:data.nopaper
            var chart = HighCharts.chart('pie1', {
                subtitle:{
                    text:'',
                },
                title: {
                    // floating:true,
                    text: '入职考试',
                    verticalAlign:'middle',
                    style: {
                        fontSize:'12px',
                        color:'#100DB1'
                    },
                    y:20
                },
                tooltip: {
                    pointFormat: '<b>{point.y:.0f}</b>',
                    headerFormat:'<span style="font-size: 16px">{series.name}</span><br/><span style="font-size: 16px">{point.key}</span>：'
                },
                colors:['#228FFE','#F7B61C','#F5A420','#FDFAE2'],
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b><br/> {point.percentage:.1f} %',
                            style:{
                                fontSize:'10px',
                                lineHeight:'20px'
                            },
                            distance:5,
                        },
                        point: {
                            events: {}
                        },
                    }
                },
                series: [{
                    type: 'pie',
                    size:'160%',
                    innerSize: '70%',
                    name: '人数',
                    // center: [80, 20],
                    data: [
                        ['已入职考试', data.paperNum],
                        ['未入职考试', data.nopaper]
                    ]
                }]
            });
        },
        setChart21(){
            var data = {
                paperNum:this.edc.paperNum||0,
                nopaper:this.edc.nopaper||0,
            }
            data.paperNum = data.paperNum==0?0.001:data.paperNum
            data.nopaper = data.wzz==0?0.001:data.nopaper
            var chart = HighCharts.chart('pie2', {
                subtitle:{
                    text:'',
                },
                title: {
                    // floating:true,
                    text: '安全教育',
                    verticalAlign:'middle',
                    style: {
                        fontSize:'14px',
                        color:'#100DB1',
                    },
                    y:20
                },
                tooltip: {
                    pointFormat: '<b>{point.y:.0f}</b>',
                    headerFormat:'<span style="font-size: 16px">{series.name}</span><br/><span style="font-size: 16px">{point.key}</span>：'
                },
                colors:['#228FFE','#F7B61C','#F5A420','#FDFAE2'],
                plotOptions: {
                    pie: {
                        allowPointSelect: true,
                        cursor: 'pointer',
                        dataLabels: {
                            enabled: true,
                            format: '<b>{point.name}</b><br/> {point.percentage:.1f} %',
                            style:{
                                fontSize:'10px',
                                lineHeight:'20px'
                            },
                            distance:5,
                        },
                        point: {
                            events: {}
                        },
                    }
                },
                series: [{
                    type: 'pie',
                    size:'160%',
                    innerSize: '70%',
                    name: '人数',
                    // center: [80, 20],
                    data: [
                        ['已受教育', data.paperNum],
                        ['未教育', data.nopaper]
                    ]
                }]
            });
        },

        //设置总包项目+分布项目
        setChart4(){
            var data = {
                zj:(parseInt(this.proNum.zbzj)+parseInt(this.proNum.fbzj))||0,
                jg:(parseInt(this.proNum.zbjg)+parseInt(this.proNum.fbjg))||0,
                tg:(parseInt(this.proNum.zbtg)+parseInt(this.proNum.zbtg))||0,
                all:(parseInt(this.proNum.zcb)+parseInt(this.proNum.fb))||0
            }
            var chart = HighCharts.chart('pie3', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: '承包项目：'+data.all,
                    x:-60
                },
                subtitle: {
                    text: ''
                },
                xAxis: {
                    type: 'category',
                    gridLineWidth: 1,
                },
                yAxis: {
                    title: {
                        text: ''
                    },
                    gridLineWidth: 1,
                    
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                            format: '{point.y:.1f}%'
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:16px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}个</b><br/>'
                },
                colors:['#228FFE','#25C07F','#F45E23'],
                series: [{
                    name: '项目数量',
                    colorByPoint: true,
                    maxPointWidth:20,
                    data: [{
                        name: '在建',
                        y: parseInt(data.zj),
                    }, {
                        name: '竣工',
                        y: parseInt(data.jg),
                    }, {
                        name: '停工',
                        y: parseInt(data.tg),
                    }]
                }],
            });

        },

        //设置分包项目
        setChart5(){
            var data = {
                zj:this.proNum.jszj||0,
                jg:this.proNum.jsjg||0,
                tg:this.proNum.jstg||0,
                all:this.proNum.js||0
            }
            var chart = HighCharts.chart('pie4', {
                chart: {
                    type: 'column'
                },
                title: {
                    text: '建管项目：'+data.all,
                    x:-60
                },
                subtitle: {
                    text: ''
                },
                xAxis: {
                    type: 'category',
                    gridLineWidth: 1,
                },
                yAxis: {
                    title: {
                        text: ''
                    }
                },
                legend: {
                    enabled: false
                },
                plotOptions: {
                    series: {
                        borderWidth: 0,
                        dataLabels: {
                            enabled: false,
                            format: '{point.y:.1f}%'
                        }
                    }
                },
                tooltip: {
                    headerFormat: '<span style="font-size:16px">{series.name}</span><br>',
                    pointFormat: '<span style="color:{point.color}">{point.name}</span>: <b>{point.y:.0f}个</b><br/>'
                },
                colors:['#228FFE','#25C07F','#F45E23'],
                series: [{
                    name: '项目数量',
                    colorByPoint: true,
                    maxPointWidth:20,
                    data: [{
                        name: '在建',
                        y: parseInt(data.zj),
                    }, {
                        name: '竣工',
                        y: parseInt(data.jg),
                    }, {
                        name: '停工',
                        y: parseInt(data.tg),
                    }]
                }],
            });

        },

        //整理今日出勤数据
        refreshAttendData(data,items,index){
            var len1 = data.toString().length
            console.log(len1);
            console.log(items);
            if(index==1){
                this.numLen1 = []
                for(var i=0;i<len1;i++){
                    this.numLen1.push('0')
                }
            }else if(index==2){
                this.numLen2 = []
                for(var i=0;i<len1;i++){
                    this.numLen2.push('0')
                }
            }else if(index==3){
                this.numLen3 = []
                for(var i=0;i<len1;i++){
                    this.numLen3.push('0')
                }
            }
            var that = this
            setTimeout(function(){
                that.setNumberTransform(data,items)
            },100)
        },
        // 设置每一位数字的偏移
        setNumberTransform (num,items) {
            let numberItems = items
            let numberArr = (num+'').split('')
            for (let index = 0; index < numberItems.length; index++) {
                let elem = numberItems[index]
                elem.style.transform = `translate(-50%, -${numberArr[index] * 10}%)`
            }
        },
        //跳转公告列表
        toNotice(){
            //this.$emit('firstMenu','noticeEnt');
            this.$store.commit('setFirstMenu', 'noticeEnt')
            this.$router.push({ name: 'noticeEnt' })
        },
        //跳转法律法规
        toLaws(){
            this.$store.commit('setFirstMenu', 'laws')
            this.$router.push({ name: 'laws' })
        },
        //跳转项目统计
        toProject(){
            //this.$emit('firstMenu','conproTotal');
            this.$store.commit('setFirstMenu', 'conproTotal')
            this.$router.push({ name: 'conproTotal' })
        },

        //项目巡查列表滚动
        scroll1(){
            if(this.postList.length>3){
                var that = this
                this.animate=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.postList.push(this.postList[0]);  // 将数组的第一个元素添加到数组的
                        this.postList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer1)
            }
        },
        //公示公告列表滚动
        scroll2(){
            if(this.noticeList.length>3){
                var that = this
                this.animate2=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.noticeList.push(this.noticeList[0]);  // 将数组的第一个元素添加到数组的
                        this.noticeList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate2 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer2)
            }
        },
        //法律列表滚动
        scroll3(){
            if(this.lawsList.length>3){
                var that = this
                this.animate3=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.lawsList.push(this.lawsList[0]);  // 将数组的第一个元素添加到数组的
                        this.lawsList.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate3 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },1000)
            }else{
                window.clearInterval(this.timer3)
            }
        },
        //项目图片
        scroll4(){
            if(this.proImg.length>2){
                var that = this
                this.animate4=true;    // 因为在消息向上滚动的时候需要添加css3过渡动画，所以这里需要设置true
                setTimeout(()=>{      //  这里直接使用了es6的箭头函数，省去了处理this指向偏移问题，代码也比之前简化了很多
                        this.proImg.push(this.proImg[0]);  // 将数组的第一个元素添加到数组的
                        this.proImg.shift();               //删除数组的第一个元素 attendTeam   
                        this.animate4 = false;  // margin-top 为0 的时候取消过渡动画，实现无缝滚动
                },2000)
            }else{
                window.clearInterval(this.timer3)
            }
        },
        stopAnimate4(){
            window.clearInterval(this.timer4)
            this.mouseFlag = false
        },
        startAnimate4(){
            if(this.timer4){
                window.clearInterval(this.timer4)
            }
            this.mouseFlag = true
            this.timer4 = setInterval(this.scroll4,2500)
        },
        //跳转详情
        toInfo(row,type){
            // if(type==1){
            //     this.$store.commit('setFirstMenu', 'noticeEnt')
            // }else{
            //     this.$store.commit('setFirstMenu', 'laws')
            // }
            this.$router.push({name:'noticeDetails',params:{id:row.id,type:type}})
        },

        //弹出框人数
        getProWorker(){
            var that = this
            myHttp.getProjectInfoByAreaJoinType({
                entId:this.groupId,
                chooseDate:util.myTime.getCurTime(),
                joinType:'',
                pageSize: 1000,
                pageNum: 1
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.pageInfo.list || []
                    // console.log(resp)
                    that.gridData1 = list
                }
            },)
        },
        //弹出框人员动态
        getProPerson(){
            var that = this
            myHttp.selectProjectByJoinTypeAndEntId({
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                if(resp.data.code=='200'){
                    var list = resp.data.data.projectInfos||[]
                    that.gridData2 = list
                }
            },)
        },
        //弹出框项目统计
        getProTotal(){
            var that = this
            //gridData3
            myHttp.firstPageProject({
                entId:this.groupId,
                joinType:''
            }).then(function(resp){
                //console.log(resp)
                if(resp.data.code=='200'){
                    var list = resp.data.data||[]
                    for(var i=0;i<list.length;i++){
                        list[i].cumulativePay = list[i].cumulativePay?list[i].cumulativePay:0
                        list[i].bilv = list[i].settlementTotal && list[i].settlementTotal!=0?(parseInt(list[i].cumulativePay)/parseInt(list[i].settlementTotal)*100).toFixed(1)+'%':'0%'
                        list[i].progress = that.filterProgress(list[i].startDate,list[i].endDate)
                    }
                    that.gridData3 = list
                }
            })
        },

        filterProgress(t1,t2){
            var result = 0
            var day = util.myTime.getCurTime()
            if(!t1 || t1==''||!t2||t2==''){
                result = 0
            }else if(new Date().getTime()<new Date(t1).getTime()){
                result = 0
            }else if(new Date().getTime()>new Date(t2).getTime()){
                result = 100
            }else{
                var str = (parseInt(util.myTime.getdayByDate(t1,day))/parseInt(util.myTime.getDaysByDate(t1,t2))*100).toFixed(2)
                result = str
            }
            return result+'%'
        },
        //弹出框安全教育
        // geteduNum(){
        //     var that = this
        //     myHttp.entSafetyEducation({
        //         groupId:this.groupId,
        //         joinType:'2'
        //     }).then(function(resp){
        //         console.log(resp)
        //         if(resp.data.code=='200'){
        //             var list = resp.data.data
        //             that.gridData4 = list
        //         }
        //     })
        // },
    }
}
</script>
<style scoped>
    .home{
        width: 100%;
        height: 100%;
        position: relative;
        padding: 20px;
        background: #ECF0F5;
    }
    .home-line{
        width: 100%;
        height: 40.3vh;
        position: relative;
        display: flex;
    }
    .line-left{
        width: 33vw;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .line-left1{
            width: 25.6vw;
    height: 100%;
    position: relative;
    display: flex;
    flex-wrap: wrap;
    background-color: #fff;
    }
    .line-right{
        width: 26vw;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
    }
    .attent-box{
        width: 100%;
        height: 16vh;
        margin-bottom: 20px;
        position: relative;
        /* border: 1px solid #ddd; */
        border-radius: 0.3vh;
        overflow: hidden;
        background-color: #fff;
    }
    .first-head{
        width: 100%;
        /* height: 3vh; */
        margin-top: 5px;
        position: relative;
        display: flex;
        align-items: center;

        justify-content: space-between;
        padding: 0 1.5vh 0 0;
    }
    .first-head p{
        width: 22%;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 0.8vw;
    }
    .first-head .crile{
        width: 0.4vh;
        height: 84%;
        display: inline-block;
        border-radius: 25px;
        /* margin-right: 1vw; */
    }
    .first-body{
        width: 100%;
        height: 70%;
        position: relative;
        display: flex;
        padding: 0 1.5vh ;
        /* align-content: center;
        align-items: center;
        font-size: 1.5vw; */
    }
    .first-body-item{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }
    .first-body-item .num{
        font-size: 3vw;
        width: 100%;
        position: relative;
        /* text-shadow:0 0 6px #fff, 0 0 8px #4D73C2; */
        /* -webkit-text-stroke: 3px #fff;
        text-stroke: 3px #fff; */
        /* text-shadow:
        #fff 4px 0 0,#fff 0 4px 0,#fff -4px 0 0,#fff 0 -4px 0, */
                    /* #4D73C2 5px 0 0,#4D73C2 0 5px 0,#4D73C2 -5px 0 0,#4D73C2 0 -5px 0, */
                    /* #4D73C2 5px 0 6px,#4D73C2 0 5px 6px,#4D73C2 -5px 0 6px,#4D73C2 0 -5px 6px;
                    
        text-shadow: 3px 0 0 #fff, 0 3px 0 #fff, -3px 0 0 #fff, 0 -3px 0 #fff,
                     0 0 6px #1E369A; */
        /* letter-spacing: 0.5vw; */
        font-family: 'open_24_display_stregular';
        color: #2566C0;
text-shadow: 7px 9px 6px 0px rgba(37, 102, 192, 0.25);
        font-weight: 600;
        display: flex;
        justify-content: center;
    }
    .person-box{
        width: 100%;
        height: 23vh;
        position: relative;
        /* margin-top: 1vh; */
        /* border: 1px solid #ddd; */
        border-radius: 0.3vh;
        overflow: hidden;
        background-color: #fff;
    }
    .first-body .echart1{
        position: absolute;
        top: -5%;
        left: 26%;
        width: 42%;
        height: 130%;
    }
    .first-gress{
        /* width: 100%;
        height: 100%;
        position: relative;
        padding-left: 50%; */
        position: absolute;
        top: 0;
        right: 0;
        width: 24%;
        height: 100%;
    }
    .first-gress-con{
        width: 10vw;
        height: 100%;
        position: relative;
        display: flex;
        flex-direction: column;
        top: -0.3vh;
        justify-content: end;
    }
    .first-gress-con p{
        width: 94px;
        /* padding: 0 1vh; */
        position: relative;
        text-align: left;
        display: flex;
        align-items: flex-end;
        align-content: flex-end;
        justify-content: space-between;
        margin-bottom: 3px;
    }
    .first-gress-con p:nth-child(1)::before{
        position: absolute;
        top: 30%;
        left: -10px;
        content: "";
        width: 6.36px;
        height: 6.36px;
        background: #228FFE;
        border-radius: 50%;
    }
    .first-gress-con p:nth-child(2)::before{
        position: absolute;
        top: 30%;
        left: -10px;
        content: "";
        width: 6.36px;
        height: 6.36px;
        background: #F7B61C;
        border-radius: 50%;
    }
    .first-gress-con p:nth-child(3)::before{
        position: absolute;
        top: 30%;
        left: -10px;
        content: "";
        width: 6.36px;
        height: 6.36px;
        background: #F45E23;
        border-radius: 50%;
    }
    .progressH{
        width: 100%;
        /* padding: 0 1vh; */
        position: relative;
        height: 1vh;
        border: 1px solid #7FD7E0;
    }
    .first-gress-con .inner{
        height: 100%;
        top: 0;
        left: 0;
        display: inline-block;
        position: relative;
    }

    .line-center{
        width: 59vw;
        height: 100%;
        padding: 0 20px;
        position: relative;
    }
    .line-center1{
        width: 44vw;
        height: 100%;
        margin: 0 0.8vw 0 0.9vw;
        position: relative;
    }
    .second-body{
        width: 100%;
        height: 80%;
        position: relative;
        display: flex;
        padding: 0 1.5vh ;
        flex-wrap: wrap;
        /* overflow: hidden; */
    }
    .second-total p{
        font-size: 0.1vh;
    }
    .hight-pie1{
        position: absolute;
        top: 0;
        left: -1vh;
        width: 28vw;
        height: 16vh;
    }
    .hight-pie2{
        width: 50%;
        height: 100%;
        position: relative;
    }
    ::v-deep tspan{
        font-size: 12px;
    }
    .pie-box{
        width: 100%;
        height: 100%;
        position: relative;
    }
    .second-footer{
        width: 100%;
        height: 20%;
        position: relative;
        display: flex;
        padding: 0 1.5vh;
        justify-content: space-around;
        flex-wrap: wrap;
    }
    .second-footer .total-p{
         font-size: 1.5vh;
         width: 50%;
    }
    .second-head{
        width: 100%;
        height: 15%;
        position: relative;
        display: flex;
        padding: 0 1.5vh;
    }
    .second-head p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        align-content: center;
        align-items: center;
        font-size: 0.9vw;
    }
    .second-head .crile{
        width: 0.4vh;
        height: 2.3vh;
        display: inline-block;
        border-radius: 25px;
        margin-right: 1vw;
    }
    .table-head{
        width: 100%;
        height: 3vh;
        position: relative;
        display: flex;
        background-color: #F7F7F7;
    }
    .table-head p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
        font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
line-height: 11px;
letter-spacing: 0px;
color: #999999;
    }
    .table-head-list{
        width: 100%;
        height: calc( 100% - 3.1vh );
        position: relative;
        overflow: hidden;

    }
    .table-li{
        width: 100%;
        height: 4vh;
        position: relative;
        display: flex;
    }
    .table-li p{
        width: 33%;
        height: 100%;
        position: relative;
        display: flex;
        justify-content: center;
        justify-items: center;
        align-content: center;
        align-items: center;
    }

    .home-line1{
        margin-top: 20px;
        height: 37vh;
        overflow: hidden;
        display: flex;
    }
    .line1-right{
        width: 26.1vw;
        height: 100%;
        position: relative;
        display: flex;
        /* border: 1px solid #ddd; */
        /* border-top: 10px solid #358ADA; */
        /* padding: 1vh; */
        background-color: #fff;
        margin-left: 0.2vw;
    }
    .deme-box,.pub-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
    }
    .deme-box{
        background-color: #fff;
    }
    .pub-box{
        padding-left: 4vh;
    }
    .demo-head{
        width: 100%;
        height: 4vh;
        display: flex;
        justify-content: space-between;
        align-content: center;
        align-items: center;
        padding: 0 0.2vh;
        font-weight: bold;
    }
    .demo-body{
        width: 100%;
        height: calc( 100% - 4vh );
        position: relative;
        display: flex;
        flex-wrap: wrap;
        padding-top: 1vh;
    }
    .demo-body .img-item{
        width: 100%;
        height: 15vh;
        position: relative;
        padding: 0.5vh;
        display: flex;
    }
    /* .demo-body .img-item  */
    .demo-ul{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
        align-content: flex-start;
    }
    .demo-ul .time{
        width: 16vh;
    }
    .demo-ul .name{
        flex: 1;
        padding-left:0.5vh;
        cursor: pointer;
    }
    .demo-ul .dec{
        width: 25vh;
        cursor: pointer;
    }
    /* 数字滚动 */
    .number-item{
        width: 2vw;
        height: 7vh;
    }
    .number-item span{
        position: relative;
        display: inline-block;
        margin-right: 10px;
        width: 100%;
        height: 100%;
        writing-mode: vertical-rl;
        text-orientation: upright;
        overflow: hidden;
    }
    .number-item i{
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%,0);
        transition: transform 1s ease-in-out;
        letter-spacing: 10px;
        font-size: 2.9vw;
    }
    .note-box{
        width: 100%;
        height: 100%;
        position: relative;
        display: flex;
        flex-wrap: wrap;
    }
    .note-box .name{
        width:100%;
        height:20%;
        position: relative;
        height: 4vh;
        position: relative;
        font-size: 1vw;
        font-weight: bold;
        line-height: 4vh;
        color: #409EFF;
    }
    .note-box .con{
        width:100%;
        height:calc( 100% - 8vh );
        position:relative;
        overflow: auto;
        text-align: left;
        text-indent:2em;
    }
    .note-box .foot{
        width:100%;
        height:4vh;
        position: relative;
        text-align: right;
        padding-right: 2vw;
        color: #E6A23C;
    }
    .anim{
        transition: all 1s;
        margin-top: -4vh;
    }
    .anim2{
        transition: all 1s;
        margin-top: -4vh;
    }
    .anim3{
        transition: all 1s;
        margin-top: -4vh;
    }
    .anim4{
        transition: all 2s;
        margin-top: -15vh;
    }
    .other{
        overflow: auto;
    }
    .videoCont{
        position: relative;
        width:100%;height:100%;
    }
    .videoCont>i{
        position: absolute;
        left: 45%;
    top: 42%;
    font-size: 4vw;
    cursor: pointer;
    color: #fff;
    }
/* video::-webkit-media-controls-fullscreen-button {
    display: none;
}
video:hover::-webkit-media-controls-enclosure {
    display: block;
    cursor: pointer;
} */
.box-cont{
    padding: 0 12px;
}
.box-cont ::v-deep span{
    text-align: left;
}
.box-cont ::v-deep p{
    text-align: left;
}
.qyjs{
    font-family: MicrosoftYaHei;
font-size: 14px !important;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
margin-left: 27px;
position: relative !important;
}
.qyjs::before{
    position: absolute;
    top: 2px;
    left: -10px;
    content: " ";
    width: 3px;
    height: 88%;
    background-color: #2566C0;
}
.qyjA::before{
    position: absolute;
    top: 2px;
    left: -10px;
    content: " ";
    width: 3px;
    height: 88%;
    background-color: #2566C0;
}
::v-deep .el-carousel__button{
    width: 10px;
height: 10px;
border-radius: 21px;
background: #8A949D;
}

::v-deep .el-carousel__indicator.is-active button{
    opacity: 1;
    width: 30px;
height: 10px;
border-radius: 21px;
background: #EBEADC;
}
.color10{
    font-family: MicrosoftYaHei;
font-size: 10px !important;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.color12{
    font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.color14{
    font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
.nowrapA{
        white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    font-family: MicrosoftYaHei;
font-size: 12px;
font-weight: normal;
line-height: 11px;
letter-spacing: 0px;
color: #797979;
}
.qyjA{
    font-family: MicrosoftYaHei;
font-size: 14px;
font-weight: normal;
letter-spacing: 0em;
color: #666666;
}
</style>
<style>
 .el-carousel{
     width: 100%;
     height: 100%;
 }
 .highcharts-credits{
     display: none;
 }
 .comhome-pop{
    height: 30vh;
    overflow: auto;
    border: none;
 }
 .comhome-pop .el-table::before{
     background-color: transparent;
 }
 @import '../../assets/css/common.css'
</style>